export default __webpack_public_path__ + "static/media/account_normal.552ece21.svg";